import React from 'react';
import ScrollToTop from './ScrollToTop';

/**
 * LandingPageWrapper - Wraps landing pages with ScrollToTop functionality
 * This ensures consistent behavior across all landing pages
 * Note: Footer is added separately in the route definitions
 */
const LandingPageWrapper = ({ children }) => {
  return (
    <>
      {children}
      <ScrollToTop />
    </>
  );
};

export default LandingPageWrapper;
